<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader></MoonLoader>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xl-3">
          <div class="row">
            <div class="w-full">
              <DashboardElementTotal
                :total="totalQuestions"
                :progress="answeredQuestions"
                :questionnaireScoreByColor="questionnaireScoreByColor"
              ></DashboardElementTotal>
            </div>
          </div>
        </div>
        <div class="col-xl-9">
          <div class="row">
            <div class="col-md-6 col-lg-4" v-for="(element, index) in summary" :key="index">
              <DashboardElementSummary :summary="element"></DashboardElementSummary>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6">
          <chart-card
            title="Total Progress"
            sub-title="Last year"
            :chart-data="totalProgressChart"
            :chart-options="activityChart.options"
          >
          </chart-card>
        </div>
        <div class="col-xl-6">
          <DashboardElementRecommendations></DashboardElementRecommendations>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryDashboardElementController from '@/controllers/DashboardElement/SummaryDashboardElementController';
import DashboardElementTotalProgressController from '@/controllers/DashboardElement/DashboardElementTotalProgressController';
import QuestionnaireScoreByColorController from '@/controllers/Question/QuestionnaireScoreByColorController';
import DashboardElementTotal from '@/components/Dashboard/DashboardElementTotal';
import ChartCard from '@/components/Cards/ChartCard';
import DashboardElementSummary from '@/components/Dashboard/DashboardElementSummary';
import DashboardElementRecommendations from '@/components/Dashboard/DashboardElementRecommendations';
import MoonLoader from '@/components/svg/SvgLoaderMoon';

export default {
  name: 'SignUpDashboard',
  components: {
    MoonLoader,
    DashboardElementRecommendations,
    DashboardElementSummary,
    ChartCard,
    DashboardElementTotal,
  },
  data() {
    return {
      summary: null,
      loading: false,
      questionType: null,
      totalProgressChart: {},
      questionnaireScoreByColor: null,
      activityChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[45, 32, 54, 65, 56, 66, 68, 70, 65, 73, 72, 70]],
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false,
          },
          height: '180px',
        },
      },
      totalPieChart: {
        data: {
          labels: ['62%', '32%', '9%'],
          series: [{ value: 62 }, { value: 32 }, { value: 9 }],
        },
        options: {},
      },
      statsCards: null,
      totalQuestions: null,
      answeredQuestions: null,
    };
  },
  async created() {
    this.loading = true;
    let summary = await this.getSummary();
    this.questionType = await this.getSignUpType();
    this.questionnaireScoreByColor = await this.getTotalPieChartData(this.questionType);

    await this.setSummary(summary);
    this.getTotalScore();
    let totalProgressChart = await this.getTotalProgressChart(this.questionType);
    await this.setTotalProgressChart(totalProgressChart);
    this.loading = false;
  },
  methods: {
    async getSummary() {
      return await SummaryDashboardElementController.index();
    },
    setSummary(summary) {
      this.summary = summary;
    },
    async getTotalProgressChart(type) {
      return await DashboardElementTotalProgressController.index(type.id);
    },
    setTotalProgressChart(totalProgressChart) {
      this.totalProgressChart = totalProgressChart;
    },
    async getSignUpType() {
      let types = await this.$store.dispatch('retrieveQuestionTypes');
      return types.find((type) => {
        return type.name === 'SignUp';
      });
    },
    async getTotalPieChartData(type) {
      let company = this.$store.getters.company;
      try {
        return await QuestionnaireScoreByColorController.show(company.company_id, {
          question_type_id: type.id,
        });
      } catch (e) {
        console.error(e);
      }
    },
    getTotalScore() {
      let totalQuestions = 0;
      let answeredQuestions = 0;

      this.summary.forEach((element) => {
        totalQuestions += element.green + element.grey + element.yellow + element.red;
        answeredQuestions += element.green + element.yellow + element.red;
      });

      this.totalQuestions = totalQuestions;
      this.answeredQuestions = answeredQuestions;
    },
  },
};
</script>

<style scoped></style>
